import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { LookupService } from 'src/app/core/services/lookup.service';
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() Message: string;
  @Output() modalEvent ? = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;

  constructor(
    private modalService: BsModalService,
    private translatorService: TranslateService,
    private lookupService: LookupService
    ) {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
     }

  ngOnInit(): void {
  }
  /**
   * Function to open modal
   */
  public openModal() {
    this.updateModalStatus(true);
    this.modalRef = this.modalService.show(this.elementView, {
      class: 'modal-dialog-centered',
    });
  }
  /**
   * Function to close modal and emit event
   */
  public confirm(value) {
    this.updateModalStatus(false);
    this.modalEvent.emit(value);
    this.modalRef.hide();
  }
  updateModalStatus(value) {
  if(window?.location?.pathname.includes('/people/details')){
     this.lookupService.updateActiveModalState(value);
    }
  }
}
